const admissionDocumentTypes = Object.freeze({
  InformeAltaBajaSAEESR06: 100,
  HojaTrámiteSEEUMESRCSEEVC07: 101,
  CertificaciónMinutaSolicitandoCiberterapia: 235,
  HojaTrámiteSAEEUMESRCSEEUC08ab: 236,
});

export default admissionDocumentTypes;
